import mixpanel from "mixpanel-browser";

import { config } from "@/services/config";
import { isDev } from "@/utils";

class MixpanelService {
  private IS_PRODUCTION_ENVIRONMENT = !isDev();

  constructor() {
    this.init();
  }

  private init() {
    if (this.IS_PRODUCTION_ENVIRONMENT) {
      mixpanel.init(config.mixpanelToken, {
        debug: true,
        track_pageview: true,
        persistence: "localStorage",
      });
    }
  }

  public userIdentify(address: string) {
    if (this.IS_PRODUCTION_ENVIRONMENT) {
      mixpanel.identify(address);
    }
  }

  public reset() {
    if (this.IS_PRODUCTION_ENVIRONMENT) {
      mixpanel.reset();
    }
  }

  public trackEvent(eventName: string, arg?: Record<string, string | number | object | boolean | undefined>) {
    if (this.IS_PRODUCTION_ENVIRONMENT) {
      mixpanel.track(eventName, { ...arg });
    }
  }
}

export const logger = new MixpanelService();
